import { request } from "./request";

export function insert(name, link, detail, paperLink, type) {
  return request({
    url: '/link/insert',
    params:{ name, link, detail, paperLink, type }
  })
}


export function queryLink(type) {
  return request({
    url: '/link/queryLink',
    params: { type }
  })
}


export function selectLink() {
  return request({
    url: '/link/selectLink',
  })
}


export function delLink(id) {
  return request({
    url: '/link/delLink',
    params: { id }
  })
}


export function totalLink(){
  return request({
    url: '/link/totalLink'
  })
}


export function modifyLink(id, name, link, detail, paperLink, type) {
  return request({
    url: '/link/modifyLink',
    params: { id, name, link, detail, paperLink, type }
  })
}